import React from "react";
import { Container, Button, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const BlogTitle =()=>{
    return(
        <>

            <div className="container-fluid">
                <div  style={{
                    // backgroundImage: 'url(./assests/images/Group154.png)',
                    // height:"300px",
                    // backgroundRepeat: "no-repeat",
                }}>
                    <Container className="d-md-block d-none">
                        <Row>
                        <div className="col-md-6" style={{backgroundImage:"url(./assests/images/Frame80.svg)",
                            backgroundSize:'contain',
                            backgroundRepeat:'round',
                            height:"250px",
                            position:'relative',
                            left:"70px",
                            padding:"20px"
                        }}>
                        <h3 className="fw-bold text-decoration-underline text-white fs-24 w-50 ps-3 pe-3">The Perfect Time to Send Corporate Gifts</h3>
                        <p className="fs-14 pt-0 ps-3 pe-3 text-white w-50">As the New Years’ approach, learn what to send as corporate gifts for maximum impact. </p>
                        <Link to="/contact-us">  <Button id="whiteBtn" className="mx-3">Know More</Button></Link>
                        </div>
                        <div className="col-md-6" style={{ 
    backgroundImage: "url(./assests/images/Frame81.svg)",
    backgroundSize: 'contain',
    backgroundRepeat: 'round',
    height: "250px",
    position: 'relative',
    right:"70px" 
}}>
    <h3 className="fw-bold text-decoration-underline text-white fs-24 w-50 px-3" style={{ position: 'absolute', top: '20px', right: '20px', textAlign: 'end' }}>Affordable Festive Gift Ideas for Employees</h3>
    <p className="fs-14 text-white text-end w-50 p-3" style={{ position: 'absolute', bottom: '0px', top:'85px', right: '20px' }}>
    Boost employee morale this festive season with thoughtful, budget-friendly gifts that show your appreciation.
    </p>
    <Link to="/contact-us"><Button id="whiteBtn" className="mx-3" style={{ position: 'absolute', bottom: '40px', right: '20px' }}>Know More</Button></Link>
</div>

                        </Row>
                    </Container>
                    <Container className="d-md-none d-block">
                        <Row>
                        <div className="col-md-6 my-2" style={{backgroundImage:"url(./assests/images/mb-1.svg)",
                            backgroundSize:'auto',
                            backgroundRepeat:'no-repeat',
                            // height:"250px",
                            // position:'relative',
                            // left:"70px",
                            padding:"20px"
                        }}>
                        <h3 className="fw-bold text-decoration-underline text-white fs-18 ">The Perfect Time to Send Corporate Gifts</h3>
                        <p className="fs-14 pt-0  text-white">As the New Years’ approach, learn what to send as corporate gifts for maximum impact. </p>
                        <Link to="./contact-us">
                        <Button id="whiteBtn">
                        Know More
                        </Button>
                        </Link>
                        
                        </div>
                        <div className="col-md-6" style={{ 
    backgroundImage: "url(./assests/images/mb-2.svg)",
    backgroundSize: 'auto',
    backgroundRepeat: 'no-repeat',
    // height: "250px",
    // position: 'relative',
    // right:"70px" 
    padding:"20px"
}}>
    <h3 className="fw-bold text-decoration-underline text-white fs-18 " >Affordable Festive Gift Ideas for Employees</h3>
    <p className="fs-14 text-white text-start">
    Boost employee morale this festive season with thoughtful, budget-friendly gifts that show your appreciation.

    </p>
    <Button id="whiteBtn" className="">Know More</Button>
</div>

                        </Row>
                    </Container>
                </div>


            </div>

        </>
    )
}

export default BlogTitle